import React from 'react';
import CustomerError from '../../../components/CustomerError';
import {UserType} from '../../../hooks/apis/useUser';
import ContestEditForm, {IContestEditForm} from '../../../components/Contest/EditForm';
import UseContest, {ContestStatus, ContestType, IContest} from '../../../hooks/apis/useContest';
import {Button, Card, Popover, Space, Table, Tag} from 'antd';
import Text from 'antd/lib/typography/Text';
import QuickRouter from '../../../utils/QuickRouter';
import useAuth from '../../../utils/AuthContext';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useMount} from 'react-use';
import useQuickRouter from '../../../utils/QuickRouter';
import CollectionWorkExportReport from '../../../components/CollectionWork/ExportReport';

export default function ManageContestListPage() {
  const auth = useAuth();
  const listState = UseContest.list();
  const quickRouter = useQuickRouter();

  function refresh() {
    listState
      .request({includeHide: true})
      .then()
      .catch(CommonApiErrorHandler);
  }

  useMount(() => {
    refresh();
  });

  if (!auth.currentUser || auth.currentUser.type !== UserType.管理员) return <CustomerError title={'无操作权限'} />;
  return (
    <div>
      <Card
        title={'活动列表'}
        extra={
          <Space>
            <Button onClick={refresh}>刷新</Button>
            <Button onClick={quickRouter.manageContestNew}>创建活动</Button>
          </Space>
        }>
        <Table<IContest> loading={listState.loading} rowKey={'id'} dataSource={listState.data} bordered>
          <Table.Column<IContest> title={'ID'} dataIndex={'id'} />
          <Table.Column<IContest> title={'活动名称'} render={(_, item) => <Text strong>{item.name}</Text>} />
          <Table.Column<IContest> title={'类型'} width={150} align={'center'} render={(_, item) => <Tag>{ContestType[item.type]}</Tag>} />
          <Table.Column<IContest>
            title={'状态'}
            align={'center'}
            width={100}
            render={(_, item) => <Tag color={['', 'success', 'purple'][item.type]}>{ContestStatus[item.status]}</Tag>}
          />
          <Table.Column<IContest>
            title={'是否隐藏'}
            align={'center'}
            width={100}
            render={(_, item) => <Tag color={item.isHide ? 'danger' : 'success'}>{item.isHide ? '隐藏' : '公开'}</Tag>}
          />
          <Table.Column<IContest>
            title={'操作'}
            align={'center'}
            width={200}
            render={(_, item) => (
              <Space>
                <a onClick={() => quickRouter.manageContestEdit(item.id)}>编辑</a>
                <a onClick={() => quickRouter.manageContestNoticeList(item.id)}>编辑通知</a>
                {item.type === ContestType.知识竞赛类 ? (
                  <Popover
                    content={
                      <Space>
                        <a onClick={() => quickRouter.manageKnowledgeTestExportReport(item.simulationKnowledgeTestId)}>答题演练</a>
                        <a onClick={() => quickRouter.manageKnowledgeTestExportReport(item.regulationKnowledgeTestId)}>正式答题</a>
                      </Space>
                    }>
                    <a>统计数据</a>
                  </Popover>
                ) : (
                  <CollectionWorkExportReport collectionWorkId={item.id} />
                )}
              </Space>
            )}
          />
        </Table>
      </Card>
    </div>
  );
}
